import * as Yup from "yup";
import { VALIDATION_ENUM } from "enums";

const requiredPositiveNumber = Yup.string()
  .required(VALIDATION_ENUM.REQUIRED)
  .test("is-positive", VALIDATION_ENUM.MIN_1, (val) => {
    if (!val) return false;
    return Number(val) > 0;
  });

const schemas: Record<string, Yup.ObjectSchema<any>> = {

  treasury_bonds: Yup.object().shape({
    quantity: requiredPositiveNumber,
    completedAt: Yup.string().required(VALIDATION_ENUM.REQUIRED),
  }),

  crypto: Yup.object().shape({
    quantity: requiredPositiveNumber,
    completedAt: Yup.string().required(VALIDATION_ENUM.REQUIRED),
  }),

  precious_stones: Yup.object().shape({
    quantity: requiredPositiveNumber,
    totalValue: requiredPositiveNumber,
    completedAt: Yup.string().required(VALIDATION_ENUM.REQUIRED),
  }),

  currencies: Yup.object().shape({
    quantity: requiredPositiveNumber,
    completedAt: Yup.string().required(VALIDATION_ENUM.REQUIRED),
  }),
};

export const getTransactionValidationSchema = (slug: string) =>
  schemas[slug] ?? null;
